<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link class="Header_menu__logo Header_menu__logo--sm" :to="{ query: $route.query }">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
        <div class="Heade__main">
          <div class="Header__menu_area Header__step_area">
            <div class="Step__box">
              <div class="Step__head">
                Step
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>1</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>2</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en Step__circle--active">
                  <span>3</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h _min-h-sp">
        <div class="inner">
          <h1 class="Form__head Form__head--mb_md">
            ご登録内容の確認
          </h1>
          <div class="Form__area">
            <div class="Form__input_box Form__input_box--line">
              <div class="Form__input_heda">
                姓
              </div>
              <div class="Form__input_info">
                {{ form.last_name }}
              </div>
            </div>
            <div class="Form__input_box Form__input_box--line">
              <div class="Form__input_heda">
                名
              </div>
              <div class="Form__input_info">
                {{ form.first_name }}
              </div>
            </div>
            <div class="Form__input_box Form__input_box--line">
              <div class="Form__input_heda">
                電話番号
              </div>
              <div class="Form__input_info">
                {{ form.phone }}
              </div>
              <div v-if="showErrors" class="Form__input_info _error">
                <div class="Form__error_box Custom_error_register">
                  <div class="Form__error_tx">
                    <label>お支払い情報の登録が失敗しました</label>
                  </div>
                </div>
              </div>
            </div>
            <button
              v-show="!isLoading"
              class="Btn__blue Form__btn Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg"
              @click.prevent="onSubmit()"
            >
              登録
            </button>
            <div v-show="isLoading" class="Zoom__loading_area">
              <div class="Loading__anime">
                <div />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SignUpLayout from '@/views/layouts/SignUpLayout'
import { mapState } from 'vuex'
import authService from '@/services/authService'
import moment from 'moment'

export default {
  name: 'RegisterStep3',
  layout: SignUpLayout,
  data() {
    return {
      isLoading: false,
      showErrors: false
    }
  },
  computed: {
    ...mapState({
      form: state => state.auth.signUpData
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const data = localStorage.getItem('step1')
      const data2 = localStorage.getItem('step2')
      if (JSON.parse(data) && JSON.parse(data2)) {
        this.form.is_free_member = true
        this.form.usage_period = JSON.parse(data).usage_period
        this.form.email = JSON.parse(data).email
        this.form.utm_source = JSON.parse(data).utm_source
        this.form.utm_medium = JSON.parse(data).utm_medium
        this.form.utm_campaign = JSON.parse(data).utm_campaign
        this.form.utm_coupon = JSON.parse(data).utm_coupon
        this.form.coupon_name = JSON.parse(data).coupon_name
        this.form.first_name = JSON.parse(data).first_name
        this.form.last_name = JSON.parse(data).last_name
        this.form.phone = JSON.parse(data).phone
        this.form.password = JSON.parse(data2).password
        this.form.confirm_password = JSON.parse(data2).confirm_password
        this.form.reasons_know = JSON.parse(data2).reasons_know
        this.form.user_introduce = JSON.parse(data2).user_introduce
        this.form.register = JSON.parse(data2).register
        this.form.join_date = moment().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    async onSubmit() {
      this.isLoading = true
      this.$store.dispatch('loading/updateLoading', true)
      const data = { ...this.form }
      authService.register(data).then(() => {
        this.$store.commit('auth/resetData')
        localStorage.removeItem('email')
        localStorage.removeItem('step1')
        localStorage.removeItem('step2')
        this.$router.push('/gift-campaign-member-register/thanks')
      }).finally(() => {
        this.isLoading = false
        this.$store.dispatch('loading/updateLoading', false)
      })
    }
  }
}
</script>
